import { storageKeys } from '../../../utils/browser-storage/storage-keys';
import qualityEventsHelpers from '../quality-events.helpers';

export const SCHOOL_ACCOUNT_QUALITY_EVENTS = {
    newSchoolCreated() {
        qualityEventsHelpers.track({
            extra: JSON.stringify(Date.now()),
            type: 'NewSchoolCreated',
            user_id: window.storage.getItem(storageKeys.user.userId)
        });
    },
    setSchoolTypeFilter(query: string, source: string) {
        qualityEventsHelpers.track({
            type: 'filter_setFilterSchoolType',
            query,
            source
        });
    },
    schoolEntry() {
        qualityEventsHelpers.track({
            extra: JSON.stringify(Date.now()),
            type: 'SchoolEntry'
        });
    }
};
